import {
    PageTitleSetter, RoleGuard, SessionGuard
} from '@agyletime/vue-3-common/src/routes/guard';
import { createRouter, createWebHistory } from 'vue-router';
import { MetricsConfigurationPage, OperationsConfigurationPage } from '../components';
import { getBasePath } from '@agyletime/vue-3-common/src/plugins/basePath';

const basePath = getBasePath();

export const router = createRouter({
    history: createWebHistory(basePath),
    routes: [
        {
            path: '/metrics_configuration',
            name: 'MetricsConfigurationPage',
            component: MetricsConfigurationPage,
            beforeEnter: RoleGuard(['view_configure_metrics'], true),
            meta: { title: 'Metrics Configuration' }
        },
        {
            path: '/operations_configuration',
            name: 'OperationsConfigurationPage',
            component: OperationsConfigurationPage,
            meta: { title: 'Operations Configuration' }
        },
        {
            path: '/build',
            name: 'BuildInfo',
            meta: { title: 'Build Info' },
            component: {
                template: `
                    <div>
                        <h1>Build Info</h1>
                        <dl class="build-info-list" style="width: 50vw; font-size: 1.2rem">
                            <div v-for="[key, value] in Object.entries(buildInfo)" :key="key" style="border-bottom: 1px dashed whitesmoke; display: flex; flex: 1fr 1fr; justify-content: space-between; margin-bottom: 1rem;">
                                <dt style="font-weight: bold;">{{ key }}</dt>
                                <dd>{{ value }}</dd>
                            </div>
                        </dl>
                    </div>
                `,
                data() {
                    return { buildInfo: __BUILD_INFO__ };
                }

            }
        }
    ]
});

router.beforeEach(SessionGuard);
router.beforeEach(PageTitleSetter);
